import { Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import { EmailSubscriptionGQLType } from 'types/dashboard-core-gqlTypes.generated';

import EmailSubscriptionSettings from '~/packages/notification-settings/ui/EmailSubscriptionsSettings';

export const EmailSubscriptionsViewContainer = ({
  emailSubscriptions,
  creditFacilitySlugs,
}: {
  creditFacilitySlugs: string[];
  emailSubscriptions: EmailSubscriptionGQLType[];
}) => {
  return (
    <Box mt="35px" mb="35px">
      <Heading as="h4" size="md" textAlign="left" marginBottom="30px">
        Email Subscriptions
      </Heading>
      <Text width="100%" mb="35px" fontSize="sm" align="left">
        Manage all email subscription settings across all Finley Dashboard
        features
      </Text>
      <EmailSubscriptionSettings
        emailSubscriptions={emailSubscriptions}
        creditFacilitySlugs={creditFacilitySlugs}
      />
    </Box>
  );
};
